import { useState, useEffect, useRef } from 'react';
import './AdditionalPaymentModal.css';
import { getSessionItem } from '../../utils/helper/session';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { getTeamMembers } from '../../services/wisdomServices/managerService';
import { AutoComplete } from 'primereact/autocomplete';
import { Can, PERMISSIONS } from '../../security';

/**
 * @function AdditionalPaymentModal
 * @param {Object} props - component props
 * @param {Function} props.onCancel - function to close the modal
 * @returns {JSX.Element} - additional Payment modal
 */
function AdditionalPaymentModal(props) {
    const loggedUser = getSessionItem("User");
    const [users, setUsers] = useState([]);
    const [user, setUser] = useState("");
    const [selectedUser, setSelectedUser] = useState(null); 
    const [reason, setReason] = useState('');
    const [amount,setAmount] = useState('');
    const [comment, setComment] = useState('');
    const debounceRef = useRef(null);
    const commentLeght = 500;

    /**
     * @type {string[]}
     */
    const reasons = [
        "Missed payment from the prior month",
        "Customer bonus",
        "Commission"
    ]
  
    const getUsers = async(event) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(async () => {
            try {
            const response = await getTeamMembers(
                loggedUser.id,
                false,
                event.query,
                1,
                100
            );

            const userList = response.data.map((user) => ({
                id: user.id,
                name: user.fullName,
                email: user.username,
            }));

            setUsers(userList);

            } catch (error) {

            console.error(error);
            }

        }, 500);


    }

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
            props.onCancel(); 
            }
          };
      
          window.addEventListener('keydown', handleKeyDown);
      
          return () => {
              window.removeEventListener('keydown', handleKeyDown);
          };
    }, [props.onCancel])

    return (
    <div className='apm-modal' id='project-form-modal'>
        <div className='close-modal'>
        <Button icon='pi pi-times' onClick={props.onCancel}/>
        </div>
        <div id='add-project-form'>
        <div className='apm-details-card'>
            <div className='apm-header'>Add Payment</div>
            <div className='apm-user-select'>
                <AutoComplete
                    field='name'
                    value={user}
                    suggestions={users}
                    completeMethod={getUsers}
                    placeholder='Search user...'
                    onChange={(e) => setUser(e.value)}
                    onSelect={(e) => setSelectedUser(e.value)}
                />
                
            </div>
        </div>
        {selectedUser && (
            <div className="apm-form">
                <div className='apm-field'>
                    <label htmlFor='input-number-currency-us'>Amount * </label>
                    <InputNumber 
                        inputId="input-number-currency-us" 
                        value={amount} 
                        onValueChange={(e) => setAmount(e.value)} 
                        mode="currency" 
                        currency="USD" 
                        locale="en-US" 
                        inputStyle={{height:"41px"}}
                    />
                </div>
                <div className='apm-field'>
                    <label htmlFor='reason'>Reason * </label>
                    <select id='reason' onChange={(e) => setReason(e.target.value)}>
                        <option value="default">Select an reason</option>
                        {reasons.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                        ))}
                    </select>
                </div>
                <div className='apm-field'>
                    <label htmlFor='payment-comment'>Comment * </label>
                    <textarea id='payment-comment' rows={10} cols={38} minLength={5} maxLength={500} placeholder='Add a comment here...' onChange={e => setComment(e.target.value)}/>
                    <div className='payment-comment-max-length-div'>
                        <span className='payment-comment-max-length-span'>{comment.length}/{commentLeght}</span>

                    </div>
                </div>
                <div className='apm-actions'>
                    <Can permission={PERMISSIONS.additionalPayments_post}>
                        <Button
                        label='Save'
                        icon="pi pi-check"
                        loading={props.loading}
                        id='add-project-btn'
                        disabled={!selectedUser || !amount || !reason || reason == 'default' || comment.length < 5}
                        onClick={() => props.addPayment({userID:selectedUser.id, userName:selectedUser.name, userEmail:selectedUser.email, reason:reason, amount:amount, comment:comment})} className='apm-btn' />
                    </Can>
                </div>
            </div>
        )}
        </div>
    </div>
    );
}

export default AdditionalPaymentModal;
